module.exports = require('./helpers/bundle-url').getBundleURL('5kpau') + "logo.c51670a8.svg";